/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.BulkResponse,
  BulkPayment: (params: vp.BulkPaymentRequest) => void,
  BulkPaymentAsync: (params: vp.BulkPaymentRequest) => Promise<vp.BulkResponse>,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostBulkPayment: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldBulkPayment, setShouldBulkPayment] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.BulkPaymentRequest>({
    BatchName: '',
    BatchData: {},
  });
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const [response, setResponse] = useState<vp.BulkResponse>({
    Success: false,
    ErrorMessage: '',
    BatchTransactionRequestID: '',
    TotalSubmittedTransactions: '',
    NumberOfRejectedTransactions: '',
    RejectedTransactions: '',
  });

  useEffect(() => {
    if (!shouldBulkPayment) return () => {};

    const PostBulkPayment = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postBulkMoneyRequest(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldBulkPayment) void PostBulkPayment();
    setShouldBulkPayment(false);
    return () => {
      source.cancel();
    };
  }, [shouldBulkPayment]);

  return [
    response,
    (_params: vp.BulkPaymentRequest) => {
      setParams(_params);
      setShouldBulkPayment(true);
    },
    async (_params: vp.BulkPaymentRequest) => {
      const res = await api.postBulkMoneyRequest(_params, source);
      return res;
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        BatchTransactionRequestID: '',
        TotalSubmittedTransactions: '',
        NumberOfRejectedTransactions: '',
        RejectedTransactions: '',
      });
      setShouldBulkPayment(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostBulkPayment);
